import React, { useState } from "react";
import { CardElement } from '@stripe/react-stripe-js';
import { useTranslation } from "react-i18next";
import { ICargo } from "../interfaces";
import { SuccessDialog } from "./SuccessDialog";
import { ErrorResponseDialog } from "./ErrorResponseDialog";
import { useApi } from "../api";
import { useToast } from '@chakra-ui/react';

export type CheckoutFormProps = {
  projectCode: string;
  product: string;
  amount: number;
  onSuccess: Function;
  elements: any;
  stripe: any;
  nftId?: string;
}
export const CheckoutForm = (props: CheckoutFormProps) => {
  const { t } = useTranslation()
  const toast = useToast()
  const api = useApi(props.projectCode)
  
  const bgColor = window.location.href.includes("localhost") ? "#000000" : "#ffc107";

  const [isLoading, setIsLoading] = useState(false)

  const handleSubmit = async (event: any) => {
    toast({
      title: '交易進行中，請稍候，請勿重覆操作避免重覆扣款',
      position: 'bottom-right',
      status: 'warning',
      duration: 9000,
      isClosable: true,
    })
    setIsLoading(true)
    event.preventDefault();
    setTimeout(() => {
      setIsLoading(false)
    }, 10 * 1000)
    const { elements, stripe, amount } = props;

    if (elements == null) {
      return;
    }

    const { error, token } = await stripe.createToken(
      elements.getElement(CardElement)
    );

    if (error) {
      console.log('error:', error);
    } else {
      setIsLoading(true)
      if (props.product === 'pledge') {
        api.registerPledgeByCreditCard(amount, token.id, (cargo: ICargo) => {
          setIsLoading(false)
          if (cargo.returnCode === '000000') {
            props.onSuccess()
            SuccessDialog({title: "Good job!", content: "質押設定完成"})
          } else {
            ErrorResponseDialog(cargo, t);
          }
        })
      }
      if (props.product === 'preSaleNft') {
        api.purchasePreSaleNftByStripe(amount, token.id, (cargo: ICargo) => {
          setIsLoading(false)
          if (cargo.returnCode === '000000') {
            props.onSuccess()
            SuccessDialog({title: "Good job!", content: "NFT預購完成"})
          } else {
            ErrorResponseDialog(cargo, t);
          }
        })
      }
      if (props.product === 'nftTrading' && props.nftId) {
        api.tradingNftByStripe(props.amount, token.id, props.nftId, (cargo: ICargo) => {
          setIsLoading(false)
          if (cargo.returnCode === '000000') {
            props.onSuccess()
            SuccessDialog({title: "Good job!", content: "NFT交易完成"})
          } else {
            ErrorResponseDialog(cargo, t);
          }
        })
      }
      if (props.product === 'topupGas') {
        api.topupGas(props.amount, token.id, `${props.projectCode} 燃料充值`, (cargo: ICargo) => {
          setIsLoading(false)
          if (cargo.returnCode === '000000') {
            props.onSuccess()
            SuccessDialog({title: "Good job!", content: "燃料充值完成"})
          } else {
            ErrorResponseDialog(cargo, t);
          }
        })
      }
    }
  };

  return (
    <>
      <div>
        <CardElement options={{ hidePostalCode: true }} />
        <div className="flex items-center justify-between mt-5">
          <button
            className="w-full text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline"
            type="button"
            style={{ backgroundColor: bgColor }}
            onClick={handleSubmit}
            disabled={isLoading}
          >
            {isLoading ? `${t('processing')}...` : t(props.product)}
          </button>
        </div>
      </div>
    </>
  );
}
